import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  logs: [],
  currentBatch: {},
  lastResult: {},
};

const calculationsSlice = createSlice({
  name: "calculations",
  initialState,
  reducers: {
    setCalculationLogs: (state, { payload }) => ({
      ...state,
      logs: [...payload.logs],
    }),
    setCalculationBatch: (state, { payload }) => ({
      ...state,
      currentBatch: { ...payload.batch },
    }),
    setLastCalculationResult: (state, { payload }) => ({
      ...state,
      lastResult: { ...payload },
    }),
    resetCalculationsState: () => ({
      logs: [],
      currentBatch: {},
      lastResult: {},
    }),
  },
});

export const {
  setCalculationLogs,
  setCalculationBatch,
  setLastCalculationResult,
  resetCalculationsState,
} = calculationsSlice.actions;

export default calculationsSlice.reducer;
